import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  images = ['url(assets/5_weichzeichner.jpg)'];

  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - FAQ');
    this.seo.updateKeywords('FAQ,Fragen');
  }
}
